import { defineStore } from 'pinia'
import { ref } from 'vue'

import ax from '@utils/axios'
import {handleError} from '@utils/helpers'
import { FORM_STATUS } from '@components/form-builder'

export const useFormStore = defineStore('partner-info-form', () => {
  const forms = ref([])
  const formsCount = ref(0)
  const sharedInfoForms = ref([])
  const isLoadingSharedInfoForms = ref(false)

  async function getAllForms(query = {}, sharedInfo = false) {
    try {
      if (sharedInfo) {
        isLoadingSharedInfoForms.value = true
      }
      const response = await ax.get('/v2/forms', {
        params: {
          ...query
        },
        paramsSerializer: {
          indexes: null,
        }
      })
      let formsArray = []
      let count = 0
      if (query.page !== -1) {
        const { items, pagination } = response.data
        formsArray = items
        count = pagination.total_items
      } else {
        formsArray = response.data
        count = undefined
      }
      if (sharedInfo) {
        sharedInfoForms.value = formsArray
        return
      }
      forms.value = formsArray
      formsCount.value = count
      return forms.value
    } catch (error) {
      handleError(error)
      throw error
    } finally {
      if (sharedInfo) {
        isLoadingSharedInfoForms.value = false
      }
    }
  }

  async function getFormDetails(formId) {
    try {
      const response = await ax.get(`/v2/forms/${formId}`)
      const data = response.data
      data.status = data.is_active ? FORM_STATUS.VISIBLE : FORM_STATUS.HIDDEN
      return response.data
    } catch (error) {
      handleError(error)
      throw error
    }
  }

  async function createForm(data) {
    try {
      const response = await ax.post('/v2/forms', data)
      return response.data
    } catch (error) {
      handleError(error)
      throw error
    }
  }

  async function editForm({ id, data }) {
    try {
      const response = await ax.patch(`/v2/forms/${id}`, data)
      return response.data
    } catch (error) {
      handleError(error)
      throw error
    }
  }

  async function fetchDealRegFormPartners(formId) {
    try {
      const response = await ax.get(`/v2/forms/${formId}/partners`)
      return response.data
    } catch (error) {
      handleError(error)
      throw error
    }
  }

  async function updateSharedInfo(formId, data) {
    try {
      const response = await ax.put(`/v2/partner-info/${formId}/form`, data)
      return response.data
    } catch (error) {
      handleError(error)
      throw error
    }
  }

  async function getPartnerSharedInfo(partnerId) {
    try {
      const response = await ax.get(`/v2/partner-info/${partnerId}`)
      return response.data
    } catch (error) {
      handleError(error)
      throw error
    }
  }

  async function updatePartnerSharedInfo(partnerId, data) {
    try {
      const response = await ax.put(`/v2/partner-info/${partnerId}/partner`, data)
      return response.data
    } catch (error) {
      handleError(error)
      throw error
    }
  }

  return {
    forms,
    formsCount,
    sharedInfoForms,
    isLoadingSharedInfoForms,
    getAllForms,
    getFormDetails,
    createForm,
    editForm,
    fetchDealRegFormPartners,
    updateSharedInfo,
    getPartnerSharedInfo,
    updatePartnerSharedInfo,
  }
})